import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-resultat-controle',
    templateUrl: './resultat-controle.component.html',
    styleUrls: ['./resultat-controle.component.scss'],
    standalone: false
})
export class ResultatControleComponent {
    constructor(public readonly modal: NgbActiveModal) {}

    /**
     * Annule et ferme la modale
     */
    onClose(): void {
        this.modal.dismiss();
    }

    /**
     * Confirmer la modification du resultat du controle
     */
    onTerminer() {
        this.modal.close(true);
    }
}
